<template>
    <div class="d-flex flex-row justify-content-center p-5">
        <admin-product-form class="w-50"></admin-product-form>
    </div>
  </template>
  
  <script>
  import AdminProductForm from './AdminProductForm';
  export default {
    components: {
      AdminProductForm
    }
  }
  </script>